import React, {useState, useEffect} from 'react';
import '../../styles/Dashboard.css'
import {useCookies} from "react-cookie";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Card from "../../components/Card";
import Table from "../../components/Table";
import Chart from "../../components/Chart";
import Astuce from "../../components/Astuce";
import Info from "../../components/Info";

function Dashboard({dark, setDark, sidebarOpen, setSidebarOpen}) {

    const toggleTheme = () => setDark(!dark);
    const [cookies] = useCookies(["token"]);
    const [torrentsThisMonth, setTorrentsThisMonth] = useState(0);
    const [torrentsChange, setTorrentsChange] = useState("");
    const [requestsThisMonth, setRequestsThisMonth] = useState(0);
    const [requestsChange, setRequestsChange] = useState("");
    const [gardenSemisCount, setGardenSemisCount] = useState(0);
    const [gardenNotesCount, setGardenNotesCount] = useState(0);
    const [recipesCount, setRecipesCount] = useState(0);

    useEffect(() => {
        const fetchTorrentsCount = async () => {
            try {
                const res = await fetch("https://api.industriegaming.fr/api/script/torrents/getall", {
                    headers: { Authorization: `Bearer ${cookies.token}` }
                });

                if (!res.ok) return;
                const data = await res.json();

                const now = new Date();
                const month = now.getMonth();
                const year = now.getFullYear();

                const count = (data || []).filter(t => {
                    if (!t.created_at) return false;
                    const d = new Date(t.created_at);
                    return d.getMonth() === month && d.getFullYear() === year;
                }).length;

                setTorrentsThisMonth(count);

                // calcul du mois précédent
                const prevMonthInfo = (() => {
                    let pm = month - 1;
                    let py = year;
                    if (pm < 0) {
                        pm = 11;
                        py = year - 1;
                    }
                    return { pm, py };
                })();

                const prevCount = (data || []).filter(t => {
                    if (!t.created_at) return false;
                    const d = new Date(t.created_at);
                    return d.getMonth() === prevMonthInfo.pm && d.getFullYear() === prevMonthInfo.py;
                }).length;

                let chipText = "";
                if (prevCount === 0) {
                    chipText = count === 0 ? "—" : "Nouveau ce mois";
                } else {
                    const diff = Math.round(((count - prevCount) / prevCount) * 100);
                    if (diff === 0) {
                        chipText = "Stable";
                    } else if (diff > 0) {
                        chipText = `↑ ${diff} % vs mois précédent`;
                    } else {
                        chipText = `↓ ${Math.abs(diff)} % vs mois précédent`;
                    }
                }

                setTorrentsChange(chipText);
            } catch (err) {
                console.error("Erreur lors du chargement des torrents :", err);
            }
        };

        fetchTorrentsCount();
    }, [cookies.token]);

    useEffect(() => {
        const fetchRequestsCount = async () => {
            try {
                const res = await fetch("https://api.industriegaming.fr/api/script/request/getall", {
                    headers: { Authorization: `Bearer ${cookies.token}` }
                });

                if (!res.ok) return;
                const data = await res.json();

                const now = new Date();
                const month = now.getMonth();
                const year = now.getFullYear();

                const count = (data || []).filter(r => {
                    if (!r.created_at) return false;
                    const d = new Date(r.created_at);
                    return d.getMonth() === month && d.getFullYear() === year;
                }).length;

                setRequestsThisMonth(count);

                // previous month
                const prevMonthInfo = (() => {
                    let pm = month - 1;
                    let py = year;
                    if (pm < 0) {
                        pm = 11;
                        py = year - 1;
                    }
                    return { pm, py };
                })();

                const prevCount = (data || []).filter(r => {
                    if (!r.created_at) return false;
                    const d = new Date(r.created_at);
                    return d.getMonth() === prevMonthInfo.pm && d.getFullYear() === prevMonthInfo.py;
                }).length;

                let chipText = "";
                if (prevCount === 0) {
                    chipText = count === 0 ? "—" : "Nouveau ce mois";
                } else {
                    const diff = Math.round(((count - prevCount) / prevCount) * 100);
                    if (diff === 0) {
                        chipText = "Stable";
                    } else if (diff > 0) {
                        chipText = `↑ ${diff} % vs mois précédent`;
                    } else {
                        chipText = `↓ ${Math.abs(diff)} % vs mois précédent`;
                    }
                }

                setRequestsChange(chipText);
            } catch (err) {
                console.error("Erreur lors du chargement des requests :", err);
            }
        };

        fetchRequestsCount();
    }, [cookies.token]);

    useEffect(() => {
        const fetchGardenSeasonStats = async () => {
            try {
                const res = await fetch("https://api.industriegaming.fr/api/garden/seasons", {
                    headers: { Authorization: `Bearer ${cookies.token}` }
                });
                if (!res.ok) return;
                const data = await res.json();

                const currentYear = new Date().getFullYear();
                const season = (data || []).find(s => Number(s.year) === currentYear || s.year === currentYear);

                if (season) {
                    const semisCount = Array.isArray(season.GardenSemis) ? season.GardenSemis.length : 0;
                    const notesCount = Array.isArray(season.GardenNotes) ? season.GardenNotes.length : 0;
                    setGardenSemisCount(semisCount);
                    setGardenNotesCount(notesCount);
                } else {
                    setGardenSemisCount(0);
                    setGardenNotesCount(0);
                }
            } catch (err) {
                console.error('Erreur lors du chargement des saisons jardin :', err);
            }
        };

        fetchGardenSeasonStats();
    }, [cookies.token]);

    useEffect(() => {
        const fetchRecipesCount = async () => {
            try {
                const res = await fetch("https://api.industriegaming.fr/api/recettes/getAll", {
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${cookies.token}` }
                });
                if (!res.ok) return;
                const data = await res.json();
                const count = Array.isArray(data) ? data.length : 0;
                setRecipesCount(count);
            } catch (err) {
                console.error('Erreur lors du chargement des recettes :', err);
            }
        };

        fetchRecipesCount();
    }, [cookies.token]);

    return (
        <div className={`dashboard ${dark ? "dark" : ""}`}>
            <Sidebar mobileOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

            <div className="main">
                <Topbar onToggleSidebar={() => setSidebarOpen(true)} onToggleTheme={toggleTheme} dark={dark} />

                <div className="content">
                    <div className="cards">
                        <Card title="Torrents" value={torrentsThisMonth.toLocaleString('fr-FR')} sub="Torrent au total ce mois-ci." chip={torrentsChange} />
                        <Card title="Requests" value={requestsThisMonth.toLocaleString('fr-FR')} sub="Au total ce mois-ci." />
                        <Card title="Jardinage" value={gardenSemisCount.toLocaleString('fr-FR')} sub="Semis cette année." chip={`${gardenNotesCount} Notes au total.`} />
                        <Card title="Recette" value={recipesCount.toLocaleString('fr-FR')} sub="Recettes disponibles." />
                    </div>

                    <div className="layout-two-cols">
                        <Table />
                        {/*<Astuce />*/}
                        <Info />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
